// action types
import { createRequestTypes } from "../../utils";

export const FETCH_BREVO_LIST = createRequestTypes("FETCH_BREVO_LIST");

export const fetchBrevoListRequest = () =>
    ({ type: FETCH_BREVO_LIST.REQUEST });

export const fetchBrevoListSuccess = (data) =>
    ({ type: FETCH_BREVO_LIST.SUCCESS, payload: { data } });

export const fetchBrevoListFailure = (error) =>
    ({ type: FETCH_BREVO_LIST.FAILURE, payload: { error } });